import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

const STORAGE_KEY = "norvellanio-cookie-consent-v1";

function updateConsent(granted) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("consent", "update", {
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
    analytics_storage: granted ? "granted" : "denied",
  });
}

export default function CookieBanner() {
  const { t, buildPath } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const handle = (granted) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ granted, at: new Date().toISOString() }),
      );
    } catch (e) {
      /* ignore */
    }
    updateConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 bg-[#0F2C59] text-white border-t-4 border-[#C5A059] shadow-2xl"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1">
          <p className="font-semibold text-sm md:text-base">
            {t("cookieBanner.title")}
          </p>
          <p className="text-xs md:text-sm text-slate-200 mt-1 leading-relaxed">
            {t("cookieBanner.description")}{" "}
            <Link
              to={buildPath("cookies")}
              data-testid="cookie-banner-learn-more"
              className="underline text-[#C5A059] hover:text-white"
            >
              {t("cookieBanner.learnMore")}
            </Link>
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 shrink-0">
          <button
            data-testid="cookie-reject-button"
            onClick={() => handle(false)}
            className="px-4 py-2 rounded-md border border-white/40 text-sm font-semibold hover:bg-white/10"
          >
            {t("cookieBanner.reject")}
          </button>
          <button
            data-testid="cookie-accept-button"
            onClick={() => handle(true)}
            className="px-4 py-2 rounded-md bg-[#C5A059] text-[#0F2C59] text-sm font-bold hover:bg-[#d4b56d]"
          >
            {t("cookieBanner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
